import React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "../../lib/ThemeContext";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./tooltip";

export const ThemeToggle = ({ testId = "theme-toggle-button" }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";
  const label = isDark ? "Switch to light mode" : "Switch to dark mode";

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            onClick={toggleTheme}
            aria-label={label}
            aria-pressed={isDark}
            data-testid={testId}
            className="h-8 w-8 inline-flex items-center justify-center border border-white/10 bg-bm-elevated text-bm-muted hover:text-bm-amber hover:border-bm-amber/60 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-bm-cyan"
          >
            {isDark ? <Sun className="w-3.5 h-3.5" /> : <Moon className="w-3.5 h-3.5" />}
          </button>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="rounded-none font-mono tracking-wide">
          {label}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};